import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const BASE_STYLES = {
    indicatorsContainer: (provided) => ({ ...provided, padding: '0px', height: '38px' }),
    valueContainer: (provided) => ({ ...provided, padding: '0 8px' }),
    placeholder: (provided) => ({ ...provided, fontSize: '12px' }),
    control: (provided, state) => ({
        ...provided,
        fontSize: '14px',
        minHeight: '38px',
        height: '38px',
        ...(state.isDisabled ? {
            backgroundColor: '#f4f6fc',
            borderColor: '#dde3f5',
            cursor: 'not-allowed',
        } : {}),
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: state.isDisabled ? 'rgba(1, 50, 137, 0.45)' : provided.color,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        borderRadius: '10px',
        boxShadow: '0 8px 28px rgba(1, 50, 137, 0.15)',
        overflow: 'hidden',
        border: '1px solid rgba(1, 50, 137, 0.12)',
        padding: 0,
    }),
    menuList: (provided) => ({ ...provided, padding: 0 }),
    option: (provided, state) => ({
        ...provided,
        fontSize: '13px',
        padding: '6px 12px',
        backgroundColor: state.isSelected
            ? state.isFocused ? 'rgba(1,50,137,0.14)' : 'rgba(1,50,137,0.09)'
            : state.isFocused ? '#eef2ff' : 'white',
        color: state.isSelected ? 'var(--appcolor)' : '#1a1a2e',
        fontWeight: state.isSelected ? 600 : 400,
        cursor: 'pointer',
    }),
};

const MENU_STYLES = BASE_STYLES;

function FormSelect({ field, options, onChange, isDisabled, inputId, id, error, isClearable, withMenu, placeholder }) {
    const { t } = useTranslation();
    return (
        <Select
            styles={withMenu ? MENU_STYLES : BASE_STYLES}
            {...field}
            {...(onChange ? { onChange } : {})}
            options={options}
            isDisabled={isDisabled}
            inputId={inputId}
            id={id}
            isClearable={isClearable}
            className={`form-control ${error ? "is-invalid" : ""}`}
            placeholder={placeholder ?? t("Select")}
        />
    );
}

export default FormSelect;
